import React, {FC} from 'react';
import styled from 'styled-components';

import {SettingsDevelopersUrl} from '../../../models/url/settingsUrlModel';
import {SettingsHeader} from '../../settingsHeader';
import {SettingsDevelopersHeaderAction} from './settingsDevelopersHeaderAction';
import {SettingsDevelopersBreadcrumbs} from './settingsDevelopersHeaderBreadcrumbs';
import {SettingsDevelopersHeaderInfoButtonContainer} from './settingsDevelopersHeaderInfoButtonContainer';
import {SettingsDevelopersHeaderTabs} from './settingsDevelopersHeaderTabs';
import {SettingsDevelopersHeaderTitleContainer} from './settingsDevelopersHeaderTitleContainer';

/*
 * Props.
 */

interface SettingsDevelopersHeaderProps {
  url: SettingsDevelopersUrl;
  shouldRenderTabs: boolean;
}

/*
 * Style.
 */

const StyledActionsWrapperDiv = styled.div`
  display: flex;
  flex-flow: row;
  gap: 10px;
`;

/*
 * Component.
 */

export const SettingsDevelopersHeader: FC<SettingsDevelopersHeaderProps> = (props) => {
  const {url, shouldRenderTabs} = props;
  return (
    <SettingsHeader
      topLine={<SettingsDevelopersBreadcrumbs url={url} />}
      tabs={shouldRenderTabs && <SettingsDevelopersHeaderTabs url={url} />}
      right={
        <StyledActionsWrapperDiv>
          <SettingsDevelopersHeaderAction url={url} />
          <SettingsDevelopersHeaderInfoButtonContainer url={url} />
        </StyledActionsWrapperDiv>
      }
    >
      <SettingsDevelopersHeaderTitleContainer url={url} />
    </SettingsHeader>
  );
};
